module.exports = __webpack_public_path__ + "static/media/audio.7a3777cc.mp3";